export class RecentlyViewed {
  static #STORAGE_KEY = 'viewedProducts';
  static #MAX_PRODUCTS = 4;

  static addProduct(handle) {
    let viewedProducts = this.getProducts();
    viewedProducts = viewedProducts.filter((h) => h !== handle);
    viewedProducts.unshift(handle);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);
    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  static getProducts() {
    return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
  }
}
